<template>
  <section class="section greeting">
    <div class="greeting__wrap">

      <!-- 사진 + 본문 -->
      <div class="greeting__body">
        <!-- 사진 -->
        <div class="greeting__photo">
          <img :src="greetingImg" alt="한국내부통제협회 회장 윤규섭" />
          <p class="greeting__position">한국내부통제협회 회장</p>
          <p class="greeting__position">오스템임플란트 전문위원</p>
          <p class="greeting__name">윤규섭</p>
        </div>

        <!-- 본문 -->
        <div class="greeting__content">
          <p>
            안녕하십니까,<br />
            <strong>한국내부통제협회 초대 회장 윤규섭</strong>입니다.<br />
            한국내부통제협회 홈페이지를 방문해주신 여러분께 깊이 감사드립니다.
          </p>
          <p>
            내부통제는 이제 단순히 회계나 재무의 문제가 아니라,
            기업과 공공기관의 지속가능한 경영과 신뢰를 지탱하는 핵심 기반이자 문화입니다.
            그러나 <strong>부실 회계, 정보 유출, 비윤리적 의사결정</strong> 등 반복되는 사례는
            내부통제의 중요성을 다시 일깨우고 있습니다.
            우리는 내부통제를 ‘형식’이 아닌 <strong>‘문화’</strong>로 정착시켜야 합니다.
          </p>
          <p>
            한국내부통제협회는 이러한 시대적 요구에 부응하여,
            내부통제 문화 확산을 위한 공적 역할을 다하고자 합니다. 특히<br />
            <strong>교육과 자격제도, 실무 가이드라인을 통한 전문성 강화,</strong><br />
            <strong>한국 실정에 맞는 프레임워크와 진단 지표 개발을 통한 표준 정립,</strong><br />
            <strong>국내외 기관과의 협력 및 정보 공유를 통한 협력 확대</strong><br />
            를 추진해 나가겠습니다.
          </p>
          <p>
            협회의 진정한 가치는 <strong>회원 여러분의 헌신과 전문성</strong>에서 비롯됩니다.
            여러분 모두가 협회의 소중한 자산이며, 내부통제 생태계 조성을 위한 중심적 역할을
            함께 해주시기를 부탁드립니다.
          </p>
          <span class="signature2">
            <p>한국내부통제협회 초대 회장</p>
            <strong>윤규섭</strong>
          </span>
          <div>
            <img :src="mainsign" alt="한국내부통제협회 회장 윤규섭" />
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import greetingImg from '@/assets/mainpic.png'
import mainsign from '@/assets/mainsign.png'
</script>

<style scoped>
.greeting__wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* 제목 */
.greeting__header {
  text-align: start;
}
.greeting__title {
  font: 700 32px/1.3 "Noto Sans KR', sans-serif";
  color: #0f172a;
}
.accent-bar {
  display: inline-block;
  width: 60px;
  height: 4px;
  background: #30308a;
  border-radius: 999px;
}

/* 본문 레이아웃 */
.greeting__body {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 40px;
  align-items: start;
  margin: 50px auto;
}

.greeting__photo {
  text-align: center;
  font-family: 'Noto Sans KR', sans-serif;
}

.greeting__photo img {
  width: 220px;
  height: auto;
  margin-bottom: 0.75rem;
  border-radius: 14px;
  width: 70%;
  box-shadow: 0 6px 18px rgba(0,0,0,.1);

}

.greeting__position {
  color: #9ca3af; /* 밝은 회색 (#9ca3af ≈ Tailwind text-gray-400) */
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;
}

.greeting__name {
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 1.25rem;
  color: #111827; /* 거의 검정에 가까운 색 */
  text-align: center;
}

.greeting__position {
  color: #9ca3af; /* 밝은 회색 (#9ca3af ≈ Tailwind text-gray-400) */
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;
}

.greeting__name {
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 1.25rem;
  color: #111827; /* 거의 검정에 가까운 색 */
  text-align: center;
}

/* 본문 텍스트 */
.greeting__content p {
  font: 400 16px/1.85 "Noto Sans KR', sans-serif";
  color: #334155;
  margin-bottom: 16px;
  word-break: keep-all;
}
.greeting__content strong {
  color: #0f172a;
  font-weight: 600;
}
.greeting__content img{
  width: 180px;
}

.signature1 {
  /* margin-top: 20px; */
  font-weight: 600;
  color: #0f172a;
}

/* 반응형 */
@media (max-width: 900px) {
  .greeting__header{
    text-align: center;
  }
  .greeting__body {
    grid-template-columns: 1fr;
  }
  .greeting__photo {
    max-width: 360px;
    margin: 0 auto;
  }
}
</style>
